module.exports = __webpack_public_path__ + "202408221624/img/help_tool.56f60f01.jpg";